"use client";

import { Tour } from "@/interface/entityInterface";
import * as React from "react";

interface Props {
  selectedTour: Tour;
  paths: any;
  setPaths: Function;
  photos: (photos: { key: string; imageUrl: string }[]) => void;
}

const Photos: React.FC<Props> = ({ paths, setPaths, selectedTour, photos }) => {
  React.useEffect(() => {
    let filledImages: any[] = [];
    if (selectedTour?.images && Array.isArray(selectedTour.images)) {
      const images = selectedTour.images.slice(0, 4);
      filledImages = [
        ...images,
        ...Array(4 - images.length).fill({ key: "", imageUrl: "" }),
      ];
    }
    setPaths(filledImages || []);
    photos(filledImages || []);
  }, [selectedTour.id]);

  return (
    <div className="w-full gap-8 sm:flex-row">
      <div className="grid grid-cols-2 place-items-center gap-5 w-full mt-5">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="w-full h-auto max-h-[400px] aspect-square border rounded-md bg-transparent-100 flex items-center justify-center overflow-hidden"
          >
            {paths[i]?.imageUrl ? (
              <img
                src={paths[i].imageUrl}
                alt={`Preview ${i + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            ) : (
              <span className="text-gray-400 text-xs">No image</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Photos;
